export const speakru = (name: string, rate: number) => {
  const synth = window.speechSynthesis;
  const voice = new SpeechSynthesisUtterance(name);
  voice.lang = "ru-RU";
  voice.pitch = 1.8;
  voice.rate = rate;
  synth.speak(voice);
};
